import React from 'react';
import Modal from './Modal';
import Slider from './Slider';
import SelectedSubCategories from './SelectedSubCategories';

export default () => {
  const [visible, setVisible] = React.useState(false);
  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-base m-0 font-bold">業種</h2>
              <p className="m-0 text-sm">
                重要度を高める業種を選択してください。
              </p>
            </div>
            <Slider />
          </div>
          <button
            className="bg-white border border-c-border rounded h-8 text-sm px-4 cursor-pointer w-24"
            onClick={() => setVisible(true)}>
            業種を設定
          </button>
          <SelectedSubCategories />
        </div>
      </div>

      <Modal visible={visible} onClose={() => setVisible(false)} />
    </>
  );
};
